var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcKey01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "key-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67299 2.26302C3.79187 2.26302 2.26693 3.78797 2.26693 5.66908C2.26693 7.5502 3.79187 9.07514 5.67299 9.07514C6.46355 9.07514 7.18953 8.80662 7.76733 8.35538C8.02672 8.15281 8.39513 8.16984 8.63472 8.39548L10.7846 10.4201C10.9184 10.5461 10.9942 10.7217 10.9942 10.9054V11.9842H12.073C12.4412 11.9842 12.7397 12.2827 12.7397 12.6509V13.7297H13.7336V11.1816L9.27431 6.7223C9.14929 6.59728 9.07905 6.42771 9.07905 6.2509V5.66908C9.07905 3.78797 7.5541 2.26302 5.67299 2.26302ZM0.933594 5.66908C0.933594 3.05159 3.05549 0.929688 5.67299 0.929688C8.29048 0.929688 10.4124 3.05159 10.4124 5.66908V5.97476L14.6764 10.2388C14.9265 10.4888 15.0669 10.828 15.0669 11.1816V13.7297C15.0669 14.4661 14.47 15.063 13.7336 15.063H12.073C11.7048 15.063 11.4063 14.7645 11.4063 14.3964V13.3176H10.3275C9.95934 13.3176 9.66087 13.0191 9.66087 12.6509V11.1934L8.11115 9.73392C7.39863 10.1621 6.56397 10.4085 5.67299 10.4085C3.05549 10.4085 0.933594 8.28658 0.933594 5.66908ZM4.45281 4.39635C4.45281 4.02816 4.75129 3.72969 5.11948 3.72969H5.20026C5.56845 3.72969 5.86693 4.02816 5.86693 4.39635C5.86693 4.76454 5.56845 5.06302 5.20026 5.06302H5.11948C4.75129 5.06302 4.45281 4.76454 4.45281 4.39635Z",
    fill: "#4A5467"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKey01);
export default __webpack_public_path__ + "static/media/ic-key-01.5a8cc6b70345933b5f0e5743e0b68caf.svg";
export { ForwardRef as ReactComponent };